define('widgets/nextTournamentBanner/viewmodel',[
        'knockout',
        'underscore'
    ], function (ko, _) {

        var NextTournamentBanner = function (tournamentCampaigns) {
            var self = this;

            self.activeTournamentCampaign = tournamentCampaigns.activeCampaign;

        };

        return NextTournamentBanner;
    }
);

